import { handleRequest } from '_services';

export const helpCenterService = {
    getLocationsForUser,
};

async function getLocationsForUser(urno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/helpcenter/locations?urno=' + urno, requestOptions, true)
        .then(data => {
            return data;
        });
}
